<nts-loader *ngIf="showLoader" [skipHeader]="false" [isVisible]="true" [animation]="true"></nts-loader>

<!-- <div class="canvas-title">
    Margine superiore (mm): {{currentRectangleTopMM}}<br>
    Margine sinistro (mm): {{currentRectangleLeftMM}}
</div> -->

<div class="canvas-container" (touchstart)="onMouseDown($event)" (touchend)="onMouseUp($event)"
    (mousedown)="onMouseDown($event)" (touchmove)="onMouseMove($event)" (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp($event)" [class.has-error]="showErrorBorder && errorList?.length > 0">
    <div class="canvas-ruler sticky-ruler-x" [style.width.px]="initialWrapperWidth" [style.height.px]="20"
        [style.alignSelf]="'center'" style="margin-left: 20px;">
        <div class="canvas-ruler-x"
            [style.backgroundSize]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-x)) var(--ruler1-h), calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-x)) var(--ruler2-h), var(--ruler1-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-y)), var(--ruler2-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-y))'">
            <ul class="ruler-x"
                [style.insetInlineStart]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'">
                <li *ngFor="let item of tallsX"
                    [style.flexBasis]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'"></li>
            </ul>
        </div>
    </div>
    <div style="display: flex;justify-content: center;">
        <div class="canvas-ruler sticky-ruler-y" [style.height.px]="initialWrapperHeight" [style.width.px]="20"
            [style.alignSelf]="'center'">
            <div class="canvas-ruler-y"
                [style.backgroundSize]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-x)) var(--ruler1-h), calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-x)) var(--ruler2-h), var(--ruler1-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler1-space) * var(--ruler-y)), var(--ruler2-h) calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space) * var(--ruler-y))'">
                <ul class="ruler-y"
                    [style.insetBlockStart]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'">
                    <li *ngFor="let item of tallsY"
                        [style.flexBasis]="'calc('+ (rulerConversionRatio)  +'px * var(--ruler2-space))'"></li>
                </ul>
            </div>
        </div>
        <div class="pdf-container">
            <div class="canvas-wrapper" [class.has-error]="showErrorBorder && errorList?.length > 0"
                #canvasWrapper="popper" [popper]="tooltipErrTemplate"
                [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
                [popperTrigger]="ngxPopperjsTriggers.hover" popperApplyClass="error"
                [popperPlacement]="ngxPopperjsPlacements.TOP" [popperPreventOverflow]="false"
                [popperHideOnScroll]="true" popperAppendTo="body">
                <pdf-viewer #pdfviewer [style.height.px]="initialWrapperHeight" [style.width.px]="initialWrapperWidth"
                    *ngIf="currentFileData" [src]="currentFileData" [render-text]="false" [original-size]="false"
                    (after-load-complete)="afterLoadComplete($event)" [show-all]="false"
                    (pageChange)="loadPageData($event)" [page]="currentPage" [show-borders]="false"
                    [fit-to-page]="false" zoom-scale="page-width"
                    [class.no-points]="!checkIfCurrentPageHasSignatures()"></pdf-viewer>
                <canvas #queryCanvas></canvas>
                <div class="canvas-placeholder" *ngIf="!checkIfCurrentPageHasSignatures()">
                    {{placeholder}}
                </div>
            </div>
        </div>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>
